/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Roadmap_MissingInputs */

const en_us2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can't find what you want?`)
};

const pt_br2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não achou o que queria?`)
};

const es_419_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿No encuentras lo que buscas?`)
};

const pt_pt2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não encontraste o que querias?`)
};

const fr_fr2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu ne trouves pas ce que tu veux ?`)
};

const de_de2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht gefunden, was du suchst?`)
};

const it_it2_community_roadmap_missing = /** @type {(inputs: Community_Roadmap_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non trovi quello che cerchi?`)
};

/**
* | output |
* | --- |
* | "Can't find what you want?" |
*
* @param {Community_Roadmap_MissingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_roadmap_missing = /** @type {((inputs?: Community_Roadmap_MissingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Roadmap_MissingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_roadmap_missing(inputs)
	if (locale === "es-419") return es_419_community_roadmap_missing(inputs)
	if (locale === "pt-PT") return pt_pt2_community_roadmap_missing(inputs)
	if (locale === "fr-FR") return fr_fr2_community_roadmap_missing(inputs)
	if (locale === "de-DE") return de_de2_community_roadmap_missing(inputs)
	if (locale === "it-IT") return it_it2_community_roadmap_missing(inputs)
	return en_us2_community_roadmap_missing(inputs)
});
export { community_roadmap_missing as "community.roadmap_missing" }